import React from "react";
import { Table, Button } from "react-bootstrap";
import ReportsService from "../../../../../../services/reports-service";

const FileTable = ({ title, files, report }) => {

  const reportService = new ReportsService

  const handlePreview = async (title, file) => {
    // console.log(report.clients[0].isin);
    // console.log(report.reportType);
    // console.log(report.interestPaymentDate);
  
    try {
      const response = await reportService.retrieveReport(
        report.reportType,
        report.reportHash,
        report.reportTitle,
        report.interestPaymentDate,
        title,
        file
      );
  
      const newWindow = window.open(response.fileURL, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null; // Prevent linking back to the original window
    } catch (error) {
      if (error.response) {
        console.error('Error fetching report preview:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else {
        console.error('Error message:', error.message);
      }
    }
  };
  

  const handleDownload = async (title, file) => {
    // window.open(`/download/${file}`, "_blank");
    try {
      // Retrieve the report using the reportService
      const response = await reportService.retrieveReport(
        report.reportType,
        report.reportHash, 
        report.reportTitle,
        report.interestPaymentDate,
        title,
        file
      );
  
      const url = response.fileURL;
      const filename = response.fileName || url.substring(url.lastIndexOf('/') + 1); // Use fileName from response if available
  
      // console.log(url, filename);
  
      const fileResponse = await fetch(url);
      if (!fileResponse.ok) throw new Error('Network response was not ok');
  
      const blob = await fileResponse.blob();
      const objectUrl = window.URL.createObjectURL(blob);
  
      // To download the report
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
  
    } catch (error) {
      if (error.response) {
        console.error('Error fetching report download:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else {
        console.error('Error message:', error.message);
      }
    }
  };

  return (
    <div className="mb-4">
      <h5>{title}</h5>
      <Table bordered hover>
        <thead>
          <tr>
            <th style={{ width: "75%" }}>Filename</th>
            <th style={{ width: "25%", textAlign: "right" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {files.length > 0 ? (
            files.map((file, idx) => (
              <tr key={idx}>
                <td>{file || "File Name"}</td>
                <td style={{ width: "25%", textAlign: "right" }}>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handlePreview(title, file)}
                    className="me-2 mx-1"
                  >
                    View
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleDownload(title, file)}
                  >
                    Download
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center">
                No files available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

const FileList = ({ files, report }) => {

  return (
    <div>
      <FileTable title="Notarized Affidavit of Undertaking" files={files[0] ? [files[0]] : []} report={report} />
      <FileTable title="BIR Ruling CTC by BIR" files={files[1] ? [files[1]] : []} report={report} />
      <FileTable title="Other Documents" files={Array.isArray(files[2]) ? files[2] : []} report={report} />
    </div>
  );
};

export default FileList;